import React from 'react'
import "./Loader.scss"


const Loader = () => {
    return (
        <div className="loading-content">          
        <img className="img-loading" src="https://cdn.taxmann.com/taxmann-images/taxmann-premium/taxmann-premium-loading.gif" alt="" />           
    </div>
    )
}

export default Loader